<template>
  <time-line
    v-if="showNewCommentInput"
    plain
    class="binnacle"
    :type="simpleTimeline"
  >
    <time-line-item
      xv-if="addNewCommentInput"
      badge-type="info"
      class="binnacle-entry"
      badge-icon="add"
    >
      <div slot="header">
        <md-avatar>
          <img-with-fallback :src="currentUser.avatar" alt="Avatar" />
        </md-avatar>
        <badge type="info">{{ currentUser.userName }}</badge>
      </div>
      <div slot="content" class="comment-content">
        <md-menu
          :md-active="menuUsers"
          :md-offset-y="5"
          md-close-on-click
          md-direction="bottom-start"
          class="textarea-margin"
        >
          <div
            v-if="addNewCommentInput"
            id="comment"
            class="textarea-taggable"
            ref="comment"
            contenteditable
            @paste="handlePaste"
            @click.stop="handleClick"
            @input.stop="handleInput"
            @keydown.delete="handleDelete"
            @keypress.stop="handleKeyPress"
          ></div>
          <md-menu-content>
            <p style="padding: 0 12px">
              <strong>@{{ search }}</strong>
            </p>
            <md-menu-item
              v-for="user in filteredUsers"
              :key="user.id"
              @click="selectedUser(user)"
              >{{ user.fullName }}</md-menu-item
            >
          </md-menu-content>
        </md-menu>
        <p v-if="taggableUsers.length">
          Escriba comentario (use @ para etiquetar usuarios)
        </p>
      </div>
      <md-button
        class="md-info md-round md-sm"
        slot="footer"
        @click="addComment"
        :disabled="submitting"
      >
        <md-progress-spinner
          :md-diameter="20"
          v-if="submitting"
          md-mode="indeterminate"
        />Agregar
      </md-button>
    </time-line-item>

    <time-line-item
      class="binnacle-entry"
      v-for="(entry, i) in sortedEntries"
      :key="i"
      badge-type="success"
      badge-icon="event_note"
      :color="entry.color"
    >
      <div slot="header">
        <md-avatar>
          <img-with-fallback :src="entry.avatar" alt="Avatar" />
        </md-avatar>
        <badge type="success">{{ entry.userName }}</badge>
        <h6 class="added-date">
          <i class="ti-time"></i>
          {{ entry.addDate | fromNowDate }}
        </h6>
      </div>

      <p slot="content" v-html="entry.note" class="time-content"></p>
    </time-line-item>
  </time-line>
</template>

<script>
import TimeLine from "./Timeline/TimeLine";
import TimeLineItem from "./Timeline/TimeLineItem";
import Badge from "./Badge";
import store from "@/store";
import { replace } from "lodash";
import { mapState } from "vuex";

import mapPermissions from "@/plugins/accountPermissions/mapPermissions";

export default {
  name: "BinnacleEntries",

  components: {
    TimeLine,
    TimeLineItem,
    Badge,
  },

  props: {
    currentUser: {
      type: Object,
      default: () => {
        const { avatar, firstName, lastName, secondLastName } =
          store.state.account;
        return {
          avatar,
          userName: `${firstName} ${lastName} ${secondLastName}`,
        };
      },
    },
    entries: {
      type: Array,
      default: () => [
        {
          avatar: "",
          userName: "",
          note: "",
          addDate: new Date(),
        },
      ],
    },
    submitting: {
      type: Boolean,
    },
    reverse: {
      type: Boolean,
    },
    showNewCommentInput: {
      type: Boolean,
      default: true,
    },
    addNewCommentInput: {
      type: Boolean,
      default: true,
    },
    taggableUsers: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  methods: {
    addComment() {
      const note = this.transformComment();
      if (!note || note === "") {
        return;
      }
      this.$emit(
        "update:newComment",
        note,
        this.taggedUsers.filter((u) => !!u.id).map((u) => u.id)
      );
      this.newComment = "";
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    timeLineItemClass(entry, i) {
      return { "timeline-inverted": i % 2 == 0 };
    },

    handleInput(e) {
      this.htmlConent = e.target.innerHTML;
      const htmlConent = e.target.innerHTML;
      this.newComment = this.transformTextInput(e.target.innerText);
      this.position = this.getCursoPosition(this.$refs.comment);

      // Checked already tagged users in comment
      if (htmlConent.match(/<b>(.*?)<\/b>/g)) {
        this.taggedUsers = htmlConent.match(/<b>(.*?)<\/b>/g).map((val) => {
          const extractedName = val.replace(/<\/?b>/g, "");
          const found = this.taggableUsers.find(
            (u) => u.fullName === extractedName
          );
          return (
            (found && {
              id: found.id,
              username: found.username,
              fullName: extractedName,
            }) ||
            {}
          );
        });

        if (this.taggedUsers.some(({ id }) => !id)) {
          const commentSplit = this.htmlConent.split(/(<\/?b>)/g);
          let userNumber = 0;
          const index = commentSplit.filter((text, index, array) => {
            const user = array[index - 1] === "<b>" && text;
            return (
              !user ||
              this.taggableUsers.some(({ fullName }) => {
                if (fullName !== user) {
                  userNumber = index;
                }
                return fullName === user;
              })
            );
          });
          this.$refs.comment.innerHTML = index.join("").replace("<b></b>", "");
          this.setCursor();
        }
      } else {
        this.taggedUsers = [];
      }

      if (this.atSignPosition > -1) {
        const offset = !this.taggedUsers.length
          ? 0
          : this.currentLineAtSign - 1;
        const realComment = this.$refs.comment.innerText;
        const tolerance = this.position - this.atSignPosition - 1 - offset;
        const atSignIndex = realComment.indexOf("@") + 1;
        this.search = realComment.substr(atSignIndex, tolerance);
        this.menuUsers = tolerance > 0 && tolerance < 30;
      } else {
        this.search = "";
        this.menuUsers = false;
      }
    },
    selectedUser({ username, fullName, id }) {
      const realComment = this.$refs.comment.innerText;
      const indexBefore = realComment.indexOf("@");
      const indexAfter = realComment.indexOf("@") + this.search.length + 1;

      const textBackward = realComment.substr(0, indexBefore);
      const textAhead = realComment.substr(indexAfter);
      let newText = textBackward + fullName + "&nbsp" + textAhead;
      if (!this.taggedUsers.some((u) => u.id === id)) {
        this.taggedUsers.push({ username, fullName, id });
      }
      this.taggedUsers.forEach(({ fullName }) => {
        newText = replace(newText, fullName, `<b>${fullName}</b>`);
      });

      const nodeIndex = this.$refs.comment.innerHTML.split("@").shift();
      const node = nodeIndex.split(/(<b>)/).length + 1;
      this.$refs.comment.innerHTML = newText
        ? newText.replaceAll("\n\n", "\n")
        : "";
      this.setCursor(node);
    },
    handleDelete(e) {
      // const htmlConent = e.target.innerHTML;
      // const commentSplit = htmlConent
      //   .split(/(<\/?b>)/g)
      //   .filter((text, index, array) => array[index - 1] === "<b>");
      // this.taggedUsers = this.taggableUsers.filter((u) =>
      //   commentSplit.includes(u.fullName)
      // );
    },
    handleKeyPress(e) {
      if (e.target.innerText.length >= this.maxLength) {
        e.preventDefault();
      }
    },
    handleClick() {
      setTimeout(() => {
        this.$refs.comment.focus();
        this.menuUsers = false;
      }, 10);
    },
    handlePaste(e) {
      e.preventDefault();
      const text = e.clipboardData.getData("text/plain");
      document.execCommand("insertText", false, text.replaceAll("\n\n", "\n"));
    },
    setCursor(node) {
      // https://stackoverflow.com/questions/6249095/how-to-set-the-caret-cursor-position-in-a-contenteditable-element-div

      const el = document.getElementById("comment");
      el.focus();
      let char = 1,
        sel; // character at which to place caret

      if (document.selection) {
        sel = document.selection.createRange();
        sel.moveStart("character", char);
        sel.select();
      } else {
        sel = window.getSelection();
        sel.collapse(el.childNodes[node], char);
      }
    },
    getCursoPosition() {
      const el = document.getElementById("comment");
      el.focus();
      let _range = document.getSelection().getRangeAt(0);
      let range = _range.cloneRange();
      range.selectNodeContents(el);
      range.setEnd(_range.endContainer, _range.endOffset);
      return range.toString().length;
    },
    transformComment() {
      const messageSplit = this.$refs.comment.innerHTML
        .split(/(<\/?b>)|&nbsp;|<div>(.*?)<\/?div>/g)
        .filter((t) => t !== undefined)
        .map((t, index, array) =>
          array[index - 1] === "<b>" ? "@" + t + " " : t
        )
        .filter((t) => !["<b>", "</b>"].includes(t));
      return messageSplit.join("");
    },

    transformTextInput(text, returnSpace) {
      let textTransform = text || "";
      const arrayElements = text
        .split(/\n|(<\/?div>)|(<\/?b>)/)
        .filter((a) => a !== undefined);
      const lines = arrayElements.filter((t) => !!t);
      textTransform = lines.join("");
      return textTransform;
    },
    reset() {
      this.taggedUsers = [];
      this.$refs.comment.innerHTML = "";
      this.search = "";
    },

    checkImportantInfo({ note = "", ...restMessage }) {
      let newNote = note;
      if (note.includes("@")) {
        this.taggableUsers.forEach(({ fullName }) => {
          newNote = replace(
            newNote,
            `@${fullName}`,
            `<ins><strong>${fullName}</strong></ins>`
          );
        });
      }
      if (this.processes.some(({ name }) => note.includes(name))) {
        this.processes.forEach(({ name }) => {
          newNote = replace(newNote, `${name}`, `<b>${name}</b>`);
        });
      }
      return { ...restMessage, note: newNote };
    },
  },

  data() {
    return {
      newComment: null,
      htmlConent: null,
      position: null,
      search: "",
      taggedUsers: [],
      menuUsers: false,
    };
  },

  computed: {
    ...mapPermissions("Sinister", "binnacle", ["add"]),
    ...mapState("catalogs", {
      rawProcesses: (state) => state["macro/Carreteras/process"],
    }),
    processes() {
      return this.rawProcesses;
    },
    simpleTimeline() {
      if (this.responsive) {
        return "simple";
      }
      return "";
    },
    sortedEntries() {
      const { reverse, entries } = this;
      const entriesTransform = entries.map((entry) =>
        this.checkImportantInfo(entry)
      );
      if (reverse) {
        return [...entriesTransform].reverse();
      }
      return entriesTransform;
    },
    filteredUsers() {
      const search = (!!this.search && this.search.trim()) || "";
      if (search.length > 1) {
        const normalizeSearch = search
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
        return this.taggableUsers
          .filter(({ fullName }) => {
            const normalizeName = fullName
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();

            return normalizeName.includes(normalizeSearch);
          })
          .filter((i) => !this.taggedUsers.some((u) => u.id === i.id));
      }
      return this.taggableUsers.filter(
        (i) => !this.taggedUsers.some((u) => !!u && u.id === i.id)
      );
    },

    //CHECK IF USER PRESS @
    currentLineAtSign() {
      if (this.newComment) {
        const realComment = this.$refs.comment.innerText;
        const atSignPosition = realComment.indexOf("@");
        const subString = realComment
          .substr(0, atSignPosition)
          .split(/\r\n|\r|\n/);
        const emptyLines = subString.filter((t) => t.length === 0);
        const lines = subString.filter((t) => !!t);
        const totalLines = emptyLines.length / 2 + lines.length;
        return Math.trunc(totalLines);
      }
      return 0;
    },
    atSignPosition() {
      if (!!this.newComment) {
        return this.newComment.indexOf("@") > -1
          ? this.newComment.indexOf("@")
          : -1;
      }
      return -1;
    },
  },
};
</script>

<style lang="less" scoped>
.time-content {
  font-size: 16px;
  white-space: pre-wrap;
}

.binnacle {
  margin-top: 0px;
}

.binnacle-entry {
  margin-bottom: 4px;
}

.binnacle-entry > .timeline-panel {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-top: 0px;
}
.comment-content {
  padding: 0px;
  width: 100%;
  height: 100%;
  .textarea-margin {
    width: 100%;
  }
  .textarea-taggable {
    font-size: 15px;
    word-break: break-all;
    border: 1px solid black;
    padding: 5px 10px 5px 10px;
    min-width: 100%;
    min-height: 60px;
    margin: 0;
    white-space: pre-wrap;
    background: rgb(226, 226, 226);
  }
  p {
    font-size: 15px;
    color: rgb(110, 110, 110);
  }
}

.added-date {
  float: right;
}
.tag-user {
  // background-color: rgb(225, 225, 255);
  color: rgb(154, 154, 252);
}
</style>



// WEBPACK FOOTER //
// src/components/BinnacleEntriesExtranet.vue